import { ICounterpartyOrdersExportParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useOrdersExport = () =>
  useExportDownload<ICounterpartyOrdersExportParams>({
    downloadPrefix: 'orders',
    getFilePath: (filename) => `/orders/exported/${filename}`,
    mutationFn: (params) => Api.orders.exportCounterpartyOrders(params),
  });
